import styled from "@emotion/styled";
import { Color } from "../../../../Theme";
var H1Title = /*#__PURE__*/ styled("h1", {
    target: "e1j711g30"
})("color:", Color.secondary100, ";margin:0.625rem 0;font-family:", function(param) {
    var theme = param.theme;
    return theme.fontFamily.alternate;
}, ";font-size:1.875rem;font-weight:normal;line-height:1.875rem;");
var H2Title = /*#__PURE__*/ styled("h2", {
    target: "e1j711g31"
})("color:", Color.secondary100, ";margin:0 0 1rem;font-family:", function(param) {
    var theme = param.theme;
    return theme.fontFamily.alternate;
}, ";font-size:1.375rem;font-weight:normal;line-height:1.125;");
var Plain = /*#__PURE__*/ styled("p", {
    target: "e1j711g32"
})("line-height:1.5;color:", Color.secondary100, ";");
var Callout = /*#__PURE__*/ styled("p", {
    target: "e1j711g33"
})("font-size:1.125rem;line-height:1.5;color:", Color.secondary100, ";margin-bottom:1rem;");
var Small = /*#__PURE__*/ styled("p", {
    target: "e1j711g34"
})("font-size:0.75rem;line-height:1.5;color:", Color.secondary100, ";");
var Tiny = /*#__PURE__*/ styled("p", {
    target: "e1j711g35"
})("font-size:0.625rem;line-height:1.5;color:", Color.secondary100, ";");
export { Callout, H1Title, H2Title, Plain, Small, Tiny };
